import type { FC } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useFeatureSwitch } from '@xing-com/hub';

import { IndustryByCompanies } from '../industry-by-companies/industry-by-companies';
import { OldIndustryByCompanies } from '../industry-by-companies/old-industry-by-companies';

export const IndustryDetail: FC = () => {
  const { isLoggedIn } = useLoginState();
  const showNewLoggedInOverview = useFeatureSwitch(
    'enable_new_logged_in_companies_overview'
  );

  if (!isLoggedIn || showNewLoggedInOverview) {
    return <IndustryByCompanies />;
  }

  return <OldIndustryByCompanies />;
};
